import { timeoff, notify } from '../wiring'
import { addTimeOffTeamLeaderNote } from '../application/add-time-off-team-leader-note'
import { approveTimeOffDept } from '../application/approve-time-off-dept'
import { approveTimeOffHr } from '../application/approve-time-off-hr'
import { createTimeOffRequest } from '../application/create-time-off-request'
import { rejectTimeOffDept } from '../application/reject-time-off-dept'
import { rejectTimeOffHr } from '../application/reject-time-off-hr'
import type { CreateTimeOffRequestInput } from '../domain/timeoff'

const useTimeOffActions = () => {
	const submitRequest = (data: CreateTimeOffRequestInput & { memberName: string }) =>
		createTimeOffRequest(timeoff, data, notify)

	const approveDept = (id: string, actorId: string, actorName: string, note: string | null) =>
		approveTimeOffDept(timeoff, id, actorId, actorName, note, notify)

	const rejectDept = (id: string, actorId: string, actorName: string, note: string | null) =>
		rejectTimeOffDept(timeoff, id, actorId, actorName, note, notify)

	const approveHr = (id: string, actorId: string, actorName: string) =>
		approveTimeOffHr(timeoff, id, actorId, actorName, notify)

	const rejectHr = (id: string, actorId: string, actorName: string, note: string) =>
		rejectTimeOffHr(timeoff, id, actorId, actorName, note, notify)

	const addNote = (id: string, authorId: string, authorName: string, note: string) =>
		addTimeOffTeamLeaderNote(timeoff, id, authorId, authorName, note, notify)

	return { submitRequest, approveDept, rejectDept, approveHr, rejectHr, addNote }
}

export { useTimeOffActions }
